export type AuthorizationError = {
  message: string;
  code: number;
};

export interface InitialState<T> {
  data: T;
  loading: boolean;
  error: string | null;
}

export const createInitialState = <T>(
  data: T,
  loading: boolean = false,
): InitialState<T> => ({
  data,
  loading,
  error: null,
});

export enum CandidateViewMode {
  LARGE = 'large', // 4 per row
  SMALL = 'small', // 6 per row (default)
  LIST = 'list', // List view
}

export const STAGES = {
  dismissed: {
    id: '0',
    name: 'Dismissed',
  },
  applicants: {
    id: '1',
    name: 'Applicants',
  },
  jury: {
    id: '2',
    name: 'Jury',
  },
  finalists: {
    id: '3',
    name: 'Finalists',
  },
};
